// extracted by mini-css-extract-plugin
export var active = "_1s-7";
export var container = "_1s-0";
export var evenWidth = "_1s-4";
export var large = "_1s-5";
export var outlet = "_1s-8";
export var slide = "_1s-2";
export var small = "_1s-6";
export var tab = "_1s-3";
export var tabs = "_1s-1";